import { lazy } from "react";

import { pushPerformanceNRO } from "@navigationRouting/dashboard/analytics_dashboard_push/__appGroupId";
import type { NavigationRoutingObject } from "@navigationRouting/types";

const LegacyPushDashboardRedirect = lazy(() =>
  import("@scenes/DashboardBuilder/LegacyPushDashboardRedirect").then((module) => ({
    default: module.LegacyPushDashboardRedirect,
  }))
);

export const legacyPushDashboardNRO: NavigationRoutingObject = {
  ...pushPerformanceNRO,
  Component: LegacyPushDashboardRedirect,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  defaultRoute: "/dashboard/analytics_dashboard_push/:appGroupId",
  showInSearchResults: false,
};
